import { render, staticRenderFns } from "./user_project_statistics_view.vue?vue&type=template&id=1f25e611&"
import script from "./user_project_statistics_view.vue?vue&type=script&lang=js&"
export * from "./user_project_statistics_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports